import { createAsyncThunk } from "@reduxjs/toolkit";
import { GameApi } from "api/game";
import { loginGameType } from "types/game";

export const getGameList = createAsyncThunk(
  "game/getGameList",
  async (gameType: string, { rejectWithValue }) => {
    try {
      const dataGameList = await GameApi.getListGame(gameType);
      return { ...dataGameList, gameType };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSubGameList = createAsyncThunk(
  "game/getSubGameList",
  async (
    {
      game_type,
      provider,
      featured,
      lobby,
      page,
      size,
    }: {
      game_type: string;
      provider?: string;
      featured?: number;
      lobby?: number;
      page?: number;
      size?: number;
    },
    { rejectWithValue }
  ) => {
    try {
      const dataSubGame = await GameApi.getSubGame(
        game_type,
        provider,
        featured,
        lobby,
        page,
        size
      );
      return { ...dataSubGame, featured, game_type, provider, lobby };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const loginGame = createAsyncThunk(
  "game/loginGame",
  async (dataLoginGame: loginGameType, { rejectWithValue }) => {
    try {
      const isMobile = /iPhone|iPad|iPod|Android|tablet/i.test(
        navigator.userAgent
      );

      const resLoginGame = await GameApi.loginGame(
        dataLoginGame.username,
        dataLoginGame,
        isMobile ? 2 : 1
      );

      return resLoginGame;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
